import { render, staticRenderFns } from "./ProgramVideo.vue?vue&type=template&id=b4c16090&scoped=true"
import script from "./ProgramVideo.vue?vue&type=script&lang=js"
export * from "./ProgramVideo.vue?vue&type=script&lang=js"
import style0 from "./ProgramVideo.vue?vue&type=style&index=0&id=b4c16090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c16090",
  null
  
)

export default component.exports